import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";

// redux
import { useSelector } from "react-redux";

//constants
import { layoutTypes } from "../constants/layout";

// layouts
import NonAuthLayout from "../Layout/NonAuthLayout";
import VerticalLayout from "../Layout/VerticalLayout/index";
import { AuthProtected } from "./AuthProtected";

import { authProtectedRoutes, publicRoutes } from "./routes";

const getLayout = (layoutType) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
   
    default:
      break;
  }
  return Layout;
};

const Index = () => {

  const layoutType = useSelector((state) => state.Layout.layoutType);

  const Layout = getLayout(layoutType);

  const RouteFallback = (
    <div style={{ padding: "3em", textAlign: "center" }}>
      <span
        className="spinner-border text-primary"
        style={{ height: "1.5em", width: "1.5em", marginRight: "0.75em" }}
        role="status"
      ></span>
      Loading ...
    </div>
  );

  return (
    <Suspense fallback={RouteFallback}>
    <Routes>
      <Route>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <NonAuthLayout>
                  {route.component}
              </NonAuthLayout>
          }
            key={idx}
            exact={true}
          />
        ))}
      </Route>

      <Route>
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                    <Layout>{route.component}</Layout>
                </AuthProtected>}
              key={idx}
              exact={true}
            />
          ))}
      </Route>
    </Routes>
    </Suspense>
  );
};

export default Index;
